// removed by extract-text-webpack-plugin
module.exports = {"borderRadiusDefault":"5px","eclipse":"#9e9fa5","pitch":"#282c31","thunder":"#6b6e72","spacing-small":"4px","spacing-medium":"8px","spacing-huge":"32px","spacing-giant":"64px","this":"GroupMessagesNull__this___2C3CP","tooltip":"GroupMessagesNull__tooltip___3cVaz","link":"GroupMessagesNull__link___1dLbt","image":"GroupMessagesNull__image___26Us4","title":"GroupMessagesNull__title___ZmRRz","subtitle":"GroupMessagesNull__subtitle___52alq","subtext":"GroupMessagesNull__subtext___D5ie6"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupMessagesNull.css
// module id = 2116
// module chunks = 4